import axios from "axios";
import auth from "../resources/api/auth";
import { Dispatch, SetStateAction } from "react";
import { BACKEND } from "@appsinti/common-utils/constants/urls";
import CurrentTemperature from "@appsinti/common-utils/interfaces/weather/CurrentTemperature";

const { Authorization } = auth;

const initCurrentTemperature = async (appId: number, setTemperature: Dispatch<SetStateAction<CurrentTemperature|null>>): Promise<boolean> => {
  try {
      const current = await axios.get<CurrentTemperature>(
        `${BACKEND}/appsinti/weather/current`,
        { headers: { "app-id": appId, Authorization } }
      );
      if(!current.data) return false;

      setTemperature(current.data);      
      return true;

    } catch (e) {
      console.error(e);
      return false;
    }
}

export default initCurrentTemperature;